import { apiConfig } from '../api-config';

export interface InsertStepRegisterParams {
  cdUser: number;
  currentStep: number;
  cdTerritory: string;
  cdAgent: string;
  tokenKey: string;
}

export const insertStepRegister = async (params: InsertStepRegisterParams) => {
  return apiConfig
    .post('api/StepRegister/create', params)
    .then((resp) => resp.data)
    .catch((err) => ({ hasErros: true, err }));
};
